import { createSelector } from 'reselect';
import { TroopProfilView } from './view/ArmyListUnitProfilV2View';
import {
  armyListUnitModelRuleToView,
  getArmyListUnitId,
  modelRuleToView,
  organisationToView,
} from './ArmyListUnitProfilV2Presenter';
import { ArmyListUnitProfilV1View } from './view/ArmyListUnitProfilV1View';
import { getArmyListUnits } from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';

export const ArmyListUnitProfilV1Presenter = createSelector(
  [getArmyListUnitId, getArmyListUnits],
  (armyListUnitId, armyListUnits): ArmyListUnitProfilV1View => {
    const armyListUnit = armyListUnits.find(
      (item) => item.id === armyListUnitId,
    );

    const unitModelRules = armyListUnit!.modelRuleUnitTroops
      .filter((item) => item.isEnabled)
      .map((item) => armyListUnitModelRuleToView(item));

    const troops = armyListUnit!.troops.map((troop) => {
      return new TroopProfilView({
        name: troop.name,
        carac: troop.carac,
        modelRules: [],
      });
    });

    const mountModelRules =
      armyListUnit?.mount?.modelRuleUnitTroops
        ?.filter((item) => !item.troopId)
        ?.map((item) =>
          modelRuleToView(item, armyListUnit!.mount?.name ?? null),
        ) ?? [];

    const mountTroops =
      armyListUnit!.mount?.troops?.map((troop) => {
        return new TroopProfilView({
          name: troop.name,
          carac: troop.carac,
          modelRules: [],
        });
      }) ?? [];

    armyListUnit!.troops.map((troop) => {
      armyListUnit!.mount?.modelRuleUnitTroops
        ?.map((item) => modelRuleToView(item, troop.name))
        ?.forEach((item) => unitModelRules.push(item));
    });

    return new ArmyListUnitProfilV1View({
      item: armyListUnit!,
      organisations: armyListUnit!.organisations.map(organisationToView),
      unitId: armyListUnit!.unit_id,
      modelRules: unitModelRules.concat(mountModelRules),
      troops: troops.concat(mountTroops),
    });
  },
);
